import { useMemo } from 'react';
import Typography from '@components/common/typography';
import { useTranslation } from 'react-i18next';
import Card from '@components/cards/card';
import styles from './styles.module.scss';
import { Icon } from '@components/icons';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import { useUserContext } from '@hooks/context/useUserContext';
import { useLocales } from '@hooks/helpers/useLocales';
import { useVerificationGuard } from '@hooks/helpers/useVerificationGuard';
import Skeleton from '@components/common/skeleton';
import { useApiQuery } from '@hooks/api/useApiQuery';
import { apiWalletService } from '@api';
import { ENewNotificationType } from '@enum';
import Button from '@components/common/button';
import { ECardStatus } from '@xeppt/xeppt-sdk/types/card';

const CardsSection = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('sections', {
        keyPrefix: 'dashboard.cards'
    });
    const { isDataLoading, user } = useUserContext();
    const { verifiedAction } = useVerificationGuard();
    const { submitLocale } = useLocales();

    const { data: cards, isLoading: isCardsLoading } = useApiQuery({
        method: () => apiWalletService.getCards(),
        notificationType: ENewNotificationType.CARD,
        deps: [user]
    });

    const filteredCards = useMemo(() => {
        return cards?.filter(
            (item) =>
                item.status === ECardStatus.ACTIVE ||
                item.status === ECardStatus.TEMPORARY_CLOSED ||
                item.status === ECardStatus.FREEZED
        );
    }, [cards]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <Typography variant="h4" className={styles.title}>
                    {t('title')}
                </Typography>
                <Button
                    className={styles.all}
                    rightIcon="arrow_right"
                    variant="text-gray"
                    onClick={() => navigate(routes.xeppt_cards)}>
                    {submitLocale('view_all')}
                </Button>
            </div>
            <div className={styles.row_wrapper}>
                <div className={styles.row}>
                    {isDataLoading || isCardsLoading ? (
                        <>
                            <Skeleton className={styles.skeleton} />
                            <Skeleton className={styles.skeleton} />
                        </>
                    ) : (
                        <>
                            {filteredCards?.map((item) => (
                                <Card showStatus={false} key={item.id} card={item} />
                            ))}
                            <div
                                className={styles.new_card}
                                onClick={() =>
                                    verifiedAction(() => navigate(routes.order_xeppt_card))
                                }>
                                <Button variant="icon-gray" size="small">
                                    <Icon name="plus" />
                                </Button>
                                <Typography variant="body3" weight="medium">
                                    {t('new_card')}
                                </Typography>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CardsSection;
